import * as React from "react";
import InputState from "../../model/form/InputState";

const FormContext = React.createContext({
  onInputUpdate: (inputState: InputState) => {},
  onInputUnmount: (inputKey) => {},
});

export default FormContext;
